import { render, staticRenderFns } from "./companyDetails.vue?vue&type=template&id=191db40f&scoped=true&"
import script from "./companyDetails.vue?vue&type=script&lang=js&"
export * from "./companyDetails.vue?vue&type=script&lang=js&"
import style0 from "./companyDetails.vue?vue&type=style&index=0&id=191db40f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191db40f",
  null
  
)

export default component.exports